import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowR = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 16,
	viewBox: "0 0 22 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M14.1065 15.4348C13.7323 15.8091 13.1255 15.8091 12.7512 15.4348C12.377 15.0606 12.377 14.4538 12.7512 14.0795L17.8741 8.95664L1.02109 8.95664C0.491816 8.95664 0.0627546 8.52758 0.0627546 7.99831C0.0627546 7.46903 0.491816 7.03997 1.02109 7.03997L17.874 7.03997L12.7512 1.91723C12.377 1.54297 12.377 0.936192 12.7512 0.561939C13.1255 0.187687 13.7323 0.187687 14.1065 0.561939L20.8551 7.31054C20.862 7.31723 20.8688 7.32403 20.8755 7.33093L21.543 7.99838L14.1065 15.4348Z",
		fill: "white"
	})]
});
const ForwardRef = forwardRef(SvgArrowR);
export { ForwardRef as ReactComponent };
